import React, {useEffect} from "react";
import $ from "jquery";
import FormBuilder from "../../../class/tool/FormBuilder";
import StoreSettingController from "../../../stories/_setting/StoreSettings/StoreSettingController";
import "../../../css/form/Form.css";

const StoreReceiptFormSheet = props => {
    const { values, errors, handleChange, handleSave } = props;
    const rows = StoreSettingController.getRows("receipt");

    const buildRow = row => {
        return FormBuilder.buildInputByType(row, values, errors, change);
    }
    const change = (attribute, returnType, val, strict = false) => {
        handleChange(rows, attribute, returnType, val, strict);
    }
    const handleSubmit = event => {
        if (event !== undefined)
            event.preventDefault();

        handleSave();
    }

    useEffect(() => {
        $("#formSettings").animate({ scrollTop: 0 }, 0);
    }, []);

    return (
        <form id={"formSettings"} className={"form inOverbox"} onSubmit={handleSubmit}>
            {
                rows.map((row, index) => (
                    <div key={ index } className="row">
                        { (row.noLabel === undefined || !row.noLabel) && <label className={ row.classnameLabel }>{ row.label }</label> }
                        { buildRow(row) }
                    </div>
                ))
            }
        </form>
    )
}

export default StoreReceiptFormSheet;
